import { Flex } from '@kvdbil/components';
import { FlexProps } from '@kvdbil/components/types/components/Flex';
import React from 'react';
import { Close } from '~/App/shared/components/IconButtons/Close';

type Props = {
  onClose(): void;
  flexProps?: FlexProps;
};

const AuthCloseButton = ({ onClose, flexProps }: Props) => {
  return (
    <Flex justify={'right'} align={'center'} {...flexProps}>
      <Close onClick={onClose} />
    </Flex>
  );
};

export default AuthCloseButton;
